import { render, staticRenderFns } from "./FormStory.vue?vue&type=template&id=681ae7ea"
import script from "./FormStory.vue?vue&type=script&lang=js"
export * from "./FormStory.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/build/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('681ae7ea')) {
      api.createRecord('681ae7ea', component.options)
    } else {
      api.reload('681ae7ea', component.options)
    }
    module.hot.accept("./FormStory.vue?vue&type=template&id=681ae7ea", function () {
      api.rerender('681ae7ea', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/dash/postCreator/components/storyTab/FormStory.vue"
export default component.exports